import styled from "styled-components";

const Footer = styled.div<{isOnTopOfPage?: boolean}>`
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${props => props.isOnTopOfPage ? "24px" : 0 };
`;

export default Footer;